module.exports = __webpack_public_path__ + "static/media/TPN-bg2.3d884647.jpg";